function chooseDocFormatToDownloadDialog () {
  return {
    restrict: 'E',
    templateUrl: '/repository/dialogs/choose-doc-format-to-download/choose-doc-format-to-download-dialog.html?$$REVISION$$'
  }
}

export { chooseDocFormatToDownloadDialog }
